import { addressPartsMatch } from 'utils/address/addressPartsMatch';

import { toJsDate } from './dateWindow';

import type { listingsTypes, serializedTypes } from '@ltvco/refresh-lib/v1';

export const findSubjectListing = (
  reportListings: listingsTypes.Listings | undefined,
  subjectProperty: serializedTypes.SerializedProperty
): listingsTypes.Listing | undefined => {
  if (!reportListings?.length) {
    return undefined;
  }

  const subjectParsed = subjectProperty.parcel_address?.parsed;
  if (!subjectParsed) {
    return undefined;
  }

  const matches = reportListings.filter((listing) =>
    addressPartsMatch(subjectParsed, listing.address?.parsed)
  );

  return matches.sort((a, b) => {
    const aDate = toJsDate(a.initial_list_date)?.getTime() ?? 0;
    const bDate = toJsDate(b.initial_list_date)?.getTime() ?? 0;
    return bDate - aDate;
  })[0];
};
